import { createAction } from 'redux-actions';
import { isJustResident, getUserUnits } from '../session/selectors';

export const vehiclesActionsTypes = {
  queryAllowListInProgress: 'queryAllowListInProgress',
  queryAllowListFail: 'queryAllowListFail',
  queryAllowListSuccess: 'queryAllowListSuccess',

  queryBlockListInProgress: 'queryBlockListInProgress',
  queryBlockListFail: 'queryBlockListFail',
  queryBlockListSuccess: 'queryBlockListSuccess',

  addVehicleToAllowListInProgress: 'addVehicleToAllowListInProgress',
  addVehicleToAllowListFail: 'addVehicleToAllowListFail',
  addVehicleToAllowListSuccess: 'addVehicleToAllowListSuccess',

  addVehicleToBlockListInProgress: 'addVehicleToBlockListInProgress',
  addVehicleToBlockListFail: 'addVehicleToBlockListFail',
  addVehicleToBlockListSuccess: 'addVehicleToBlockListSuccess',

  deleteVehicleFromAllowListInProgress: 'deleteVehicleFromAllowListInProgress',
  deleteVehicleFromAllowListFail: 'deleteVehicleFromAllowListFail',
  deleteVehicleFromAllowListSuccess: 'deleteVehicleFromAllowListSuccess',

  deleteVehicleFromBlockListInProgress: 'deleteVehicleFromBlockListInProgress',
  deleteVehicleFromBlockListFail: 'deleteVehicleFromBlockListFail',
  deleteVehicleFromBlockListSuccess: 'deleteVehicleFromBlockListSuccess',

  validatePlateInAllowListInProgress: 'validatePlateInAllowListInProgress',
  validatePlateInAllowListFail: 'validatePlateInAllowListFail',
  validatePlateInAllowListSuccess: 'validatePlateInAllowListSuccess',
  validatePlateInAllowListReset: 'validatePlateInAllowListReset',

  queryResidentAccessMatchesInProgress: 'queryResidentAccessMatchesInProgress',
  queryResidentAccessMatchesFail: 'queryResidentAccessMatchesFail',
  queryResidentAccessMatchesSuccess: 'queryResidentAccessMatchesSuccess',
  queryResidentAccessMatchesReset: 'queryResidentAccessMatchesReset',

  queryAccountPlateMatchesInProgress: 'queryAccountPlateMatchesInProgress',
  queryAccountPlateMatchesFail: 'queryAccountPlateMatchesFail',
  queryAccountPlateMatchesSuccess: 'queryAccountPlateMatchesSuccess',
  queryAccountPlateMatchesReset: 'queryAccountPlateMatchesReset',

  backfillMatchesInProgress: 'backfillMatchesInProgress',
  backfillMatchesFail: 'backfillMatchesFail',
  backfillMatchesSuccess: 'backfillMatchesSuccess',
  backfillMatchesReset: 'backfillMatchesReset'
};

const queryAllowListInProgress = createAction(
  vehiclesActionsTypes.queryAllowListInProgress
);
const queryAllowListFail = createAction(
  vehiclesActionsTypes.queryAllowListFail
);
const queryAllowListSuccess = createAction(
  vehiclesActionsTypes.queryAllowListSuccess
);

const queryBlockListInProgress = createAction(
  vehiclesActionsTypes.queryBlockListInProgress
);
const queryBlockListFail = createAction(
  vehiclesActionsTypes.queryBlockListFail
);
const queryBlockListSuccess = createAction(
  vehiclesActionsTypes.queryBlockListSuccess
);

const addVehicleToAllowListInProgress = createAction(
  vehiclesActionsTypes.addVehicleToAllowListInProgress
);
const addVehicleToAllowListFail = createAction(
  vehiclesActionsTypes.addVehicleToAllowListFail
);
const addVehicleToAllowListSuccess = createAction(
  vehiclesActionsTypes.addVehicleToAllowListSuccess
);

const addVehicleToBlockListInProgress = createAction(
  vehiclesActionsTypes.addVehicleToBlockListInProgress
);
const addVehicleToBlockListFail = createAction(
  vehiclesActionsTypes.addVehicleToBlockListFail
);
const addVehicleToBlockListSuccess = createAction(
  vehiclesActionsTypes.addVehicleToBlockListSuccess
);

const deleteVehicleFromAllowListInProgress = createAction(
  vehiclesActionsTypes.deleteVehicleFromAllowListInProgress
);
const deleteVehicleFromAllowListFail = createAction(
  vehiclesActionsTypes.deleteVehicleFromAllowListFail
);
const deleteVehicleFromAllowListSuccess = createAction(
  vehiclesActionsTypes.deleteVehicleFromAllowListSuccess
);

const deleteVehicleFromBlockListInProgress = createAction(
  vehiclesActionsTypes.deleteVehicleFromBlockListInProgress
);
const deleteVehicleFromBlockListFail = createAction(
  vehiclesActionsTypes.deleteVehicleFromBlockListFail
);
const deleteVehicleFromBlockListSuccess = createAction(
  vehiclesActionsTypes.deleteVehicleFromBlockListSuccess
);

const validatePlateInAllowListInProgress = createAction(
  vehiclesActionsTypes.validatePlateInAllowListInProgress
);
const validatePlateInAllowListFail = createAction(
  vehiclesActionsTypes.validatePlateInAllowListFail
);
const validatePlateInAllowListSuccess = createAction(
  vehiclesActionsTypes.validatePlateInAllowListSuccess
);
const validatePlateInAllowListReset = createAction(
  vehiclesActionsTypes.validatePlateInAllowListReset
);

const queryResidentAccessMatchesInProgress = createAction(
  vehiclesActionsTypes.queryResidentAccessMatchesInProgress
);
const queryResidentAccessMatchesFail = createAction(
  vehiclesActionsTypes.queryResidentAccessMatchesFail
);
const queryResidentAccessMatchesSuccess = createAction(
  vehiclesActionsTypes.queryResidentAccessMatchesSuccess
);
const queryResidentAccessMatchesReset = createAction(
  vehiclesActionsTypes.queryResidentAccessMatchesReset
);

const queryAccountPlateMatchesInProgress = createAction(
  vehiclesActionsTypes.queryAccountPlateMatchesInProgress
);
const queryAccountPlateMatchesFail = createAction(
  vehiclesActionsTypes.queryAccountPlateMatchesFail
);
const queryAccountPlateMatchesSuccess = createAction(
  vehiclesActionsTypes.queryAccountPlateMatchesSuccess
);
const queryAccountPlateMatchesReset = createAction(
  vehiclesActionsTypes.queryAccountPlateMatchesReset
);

const backfillMatchesInProgress = createAction(
  vehiclesActionsTypes.backfillMatchesInProgress
);
const backfillMatchesFail = createAction(
  vehiclesActionsTypes.backfillMatchesFail
);
const backfillMatchesSuccess = createAction(
  vehiclesActionsTypes.backfillMatchesSuccess
);
const backfillMatchesReset = createAction(
  vehiclesActionsTypes.backfillMatchesReset
);

const addVehicleToAllowList = payload => {
  return (dispatch, getState, Api) => {
    const crowdModule = Api.getModule('crowd');
    crowdModule.adapter.token = getState().session.user.token;
    crowdModule.adapter.communityId = getState().session.profile.community.id;
    dispatch(addVehicleToAllowListInProgress(payload));
    return crowdModule
      .saveInAllowList(payload)
      .then(() => {
        dispatch(addVehicleToAllowListSuccess());
        dispatch(queryAllowList({ page: 0, size: 25 }));
      })
      .catch(error => {
        dispatch(
          addVehicleToAllowListFail({
            apiError: error.apiErrors
          })
        );
      });
  };
};

const queryAllowList = query => {
  return (dispatch, getState, Api) => {
    const crowdModule = Api.getModule('crowd');
    crowdModule.adapter.token = getState().session.user.token;
    crowdModule.adapter.communityId = getState().session.profile.community.id;

    dispatch(queryAllowListInProgress());

    const UserIsJustResident = isJustResident(getState());

    if (UserIsJustResident && !query['unit-id']) {
      const userUnits = getUserUnits(getState());
      if (userUnits && userUnits.length > 0) {
        query['unit-id'] = userUnits[0].id;
      }
    }

    return crowdModule
      .getAllInAllowList(query)
      .then(allowList => {
        dispatch(queryAllowListSuccess(allowList));
      })
      .catch(error => {
        dispatch(
          queryAllowListFail({
            apiError: error.apiErrors
          })
        );
      });
  };
};

const fetchAllowListPage = query => {
  return (dispatch, getState, Api) => {
    const crowdModule = Api.getModule('crowd');
    crowdModule.adapter.token = getState().session.user.token;
    crowdModule.adapter.communityId = getState().session.profile.community.id;

    const nextQuery = { ...query };
    const userIsJustResident = isJustResident(getState());

    if (userIsJustResident && !nextQuery['unit-id']) {
      const userUnits = getUserUnits(getState());
      if (userUnits && userUnits.length > 0) {
        nextQuery['unit-id'] = userUnits[0].id;
      }
    }

    return crowdModule.getAllInAllowList(nextQuery);
  };
};

const deleteVehicleFromAllowList = id => {
  return (dispatch, getState, Api) => {
    const crowdModule = Api.getModule('crowd');
    crowdModule.adapter.token = getState().session.user.token;
    crowdModule.adapter.communityId = getState().session.profile.community.id;
    dispatch(deleteVehicleFromAllowListInProgress(id));
    return crowdModule
      .deleteElementInAllowList(id)
      .then(() => {
        dispatch(deleteVehicleFromAllowListSuccess());
        dispatch(queryAllowList({ page: 0, size: 25 }));
      })
      .catch(error => {
        dispatch(
          deleteVehicleFromAllowListFail({
            apiError: error.apiErrors
          })
        );
      });
  };
};

const fetchBlockListPage = query => {
  return (dispatch, getState, Api) => {
    const crowdModule = Api.getModule('crowd');
    crowdModule.adapter.token = getState().session.user.token;
    crowdModule.adapter.communityId = getState().session.profile.community.id;

    return crowdModule.getAllInBlockList(query);
  };
};

const queryBlockList = query => {
  return (dispatch, getState, Api) => {
    const crowdModule = Api.getModule('crowd');
    crowdModule.adapter.token = getState().session.user.token;
    crowdModule.adapter.communityId = getState().session.profile.community.id;

    dispatch(queryBlockListInProgress());

    return crowdModule
      .getAllInBlockList(query)
      .then(blockList => {
        dispatch(queryBlockListSuccess(blockList));
      })
      .catch(error => {
        dispatch(
          queryBlockListFail({
            apiError: error.apiErrors
          })
        );
      });
  };
};

const addVehicleToBlockList = payload => {
  return (dispatch, getState, Api) => {
    const crowdModule = Api.getModule('crowd');
    crowdModule.adapter.token = getState().session.user.token;
    crowdModule.adapter.communityId = getState().session.profile.community.id;
    dispatch(addVehicleToBlockListInProgress(payload));
    return crowdModule
      .saveInBlockList(payload)
      .then(() => {
        dispatch(addVehicleToBlockListSuccess());
        dispatch(queryBlockList({ page: 0, limit: 25 }));
      })
      .catch(error => {
        dispatch(
          addVehicleToBlockListFail({
            apiError: error.apiErrors
          })
        );
      });
  };
};

const deleteVehicleFromBlockList = id => {
  return (dispatch, getState, Api) => {
    const crowdModule = Api.getModule('crowd');
    crowdModule.adapter.token = getState().session.user.token;
    crowdModule.adapter.communityId = getState().session.profile.community.id;
    dispatch(deleteVehicleFromBlockListInProgress(id));
    return crowdModule
      .deleteElementInBlockList(id)
      .then(() => {
        dispatch(deleteVehicleFromBlockListSuccess());
        dispatch(queryBlockList({ page: 0, limit: 25 }));
      })
      .catch(error => {
        dispatch(
          deleteVehicleFromBlockListFail({
            apiError: error.apiErrors
          })
        );
      });
  };
};

const validatePlateInAllowList = licensePlate => {
  return (dispatch, getState, Api) => {
    const crowdModule = Api.getModule('crowd');
    crowdModule.adapter.token = getState().session.user.token;
    crowdModule.adapter.communityId = getState().session.profile.community.id;
    dispatch(validatePlateInAllowListInProgress());
    return crowdModule
      .getAllInAllowList({ 'license-plate': licensePlate, page: 0, size: 1 })
      .then(result => {
        dispatch(validatePlateInAllowListSuccess(result));
      })
      .catch(error => {
        dispatch(validatePlateInAllowListFail());
      });
  };
};

const resetValidatePlate = () => {
  return dispatch => {
    dispatch(validatePlateInAllowListReset());
  };
};

const queryResidentAccessMatches = (licensePlate, includeVariants = true) => {
  return (dispatch, getState, Api) => {
    const guardModule = Api.getModule('guard');
    guardModule.adapter.token = getState().session.user.token;
    guardModule.adapter.communityId = getState().session.profile.community.id;

    dispatch(queryResidentAccessMatchesInProgress());

    return guardModule
      .getLprPlateMatches({
        'license-plate': licensePlate,
        'ocr-mode': 'FUZZY_VISUAL',
        'include-samples': true,
        'sample-size': 5,
        'min-confidence': 10,
        'include-variants': includeVariants
      })
      .then(result => {
        dispatch(queryResidentAccessMatchesSuccess(result));
      })
      .catch(error => {
        dispatch(
          queryResidentAccessMatchesFail({
            apiError: error.apiErrors
          })
        );
      });
  };
};

const resetResidentAccessMatches = () => {
  return dispatch => {
    dispatch(queryResidentAccessMatchesReset());
  };
};

const queryAccountPlateMatches = (accountIds, page = 0, size = 20) => {
  return (dispatch, getState, Api) => {
    const guardModule = Api.getModule('guard');
    guardModule.adapter.token = getState().session.user.token;
    guardModule.adapter.communityId = getState().session.profile.community.id;

    dispatch(queryAccountPlateMatchesInProgress());

    return guardModule
      .getAccountPlateMatches(accountIds, page, size)
      .then(result => {
        dispatch(queryAccountPlateMatchesSuccess(result));
      })
      .catch(error => {
        dispatch(
          queryAccountPlateMatchesFail({
            apiError: error.apiErrors
          })
        );
      });
  };
};

const resetAccountPlateMatches = () => {
  return dispatch => {
    dispatch(queryAccountPlateMatchesReset());
  };
};

const backfillResidentAccessMatches = ({ start, end }) => {
  return (dispatch, getState, Api) => {
    const guardModule = Api.getModule('guard');
    guardModule.adapter.token = getState().session.user.token;
    guardModule.adapter.communityId = getState().session.profile.community.id;

    dispatch(backfillMatchesInProgress());

    return guardModule
      .backfillLprMatches({
        'decision-at-start': start,
        'decision-at-end': end
      })
      .then(result => {
        dispatch(backfillMatchesSuccess(result));
      })
      .catch(error => {
        dispatch(
          backfillMatchesFail({
            apiError: error.apiErrors
          })
        );
      });
  };
};

const resetBackfillMatches = () => {
  return dispatch => {
    dispatch(backfillMatchesReset());
  };
};

export const vehiclesActions = {
  queryAllowList,
  fetchAllowListPage,
  fetchBlockListPage,
  queryBlockList,
  addVehicleToAllowList,
  addVehicleToBlockList,
  deleteVehicleFromAllowList,
  deleteVehicleFromBlockList,
  validatePlateInAllowList,
  resetValidatePlate,
  queryResidentAccessMatches,
  resetResidentAccessMatches,
  queryAccountPlateMatches,
  resetAccountPlateMatches,
  backfillResidentAccessMatches,
  resetBackfillMatches
};
